import { combineReducers } from 'redux';

import * as TYPES from './TYPES';

const initialUserSearchBarState = {
  input: '',
  selected: 'Username',
  selectedAction: ''
};

const usersInitialState = {
  data: [],
  paging: {},
  currentPage: 0,
  selectedUser: null,
  roles: [],
  entities: []
};

const searchBarReducer = (state = initialUserSearchBarState, action = {}) => {
  switch (action.type) {
    case TYPES.INPUT_TEXT_CHANGE:
      return { ...state, ...action.payload };
    case TYPES.SELECT_TYPE_CHANGE:
      if (state.selected === action.payload.selected) return state;
      return {
        ...state,
        ...action.payload
      };
    case TYPES.SELECT_ACTIONTYPE_CHANGE:
      if (state.selectedAction === action.payload.selectedAction) return state;
      return {
        ...state,
        ...action.payload
      };
    default:
      return state;
  }
};

const users = (state = usersInitialState, action) => {
  switch (action.type) {
    case 'GET_BUSINESSENTITIES':
      return {
        ...usersInitialState,
        loading: true
      };
    case `${TYPES.GET_USERS}_PENDING`:
      return {
        ...state,
        ...{
          selectedUser: null,
          loading: true
        }
      };
    case `${TYPES.GET_USERS}`:
      return {
        ...usersInitialState,
        loading: true
      };
    case `${TYPES.GET_USERS}_FULFILLED`:
      return {
        ...state,
        ...action.payload,
        loading: false
      };
    case `${TYPES.GET_USERS}_REJECTED`:
      return {
        ...state,
        ...action.payload,
        loading: false
      };
    case 'LOAD_MORE_USERS':
      return {
        loading: true
      };
    case 'LOAD_MORE_USERS_SUCCESS':
      return {
        ...state,
        ...action.users,
        currentPage: action.currentPage,
        sortQuery: action.sortQuery,
        loading: false
      };
    case `${TYPES.GET_USER}_PENDING`:
      return { ...state, selectedUser: null };
    case `${TYPES.GET_USER}`:
    case `${TYPES.GET_USER}_FULFILLED`:
      return { ...state, selectedUser: action.payload };
    case 'DELETE_USER':
      return {
        ...state,
        data: state.data.filter(user => user.userId !== action.userId),
        selectedUserId: null,
        toolbarMode: 'LIST'
      };
    case 'SEARCH_BUTTON_CLICK':
      return { ...state, toolbarMode: 'SEARCH' };
    case 'SEARCH_USERS_SUCESS':
      return {
        ...action.users,
        toolbarMode: 'SEARCH',
        searchString: action.searchString
      };
    case 'CLOSE_BUTTON_CLICK':
      return { ...state, toolbarMode: 'LIST' };

    case `${TYPES.GET_ROLES}_PENDING`:
    case `${TYPES.GET_ENTITIES}_PENDING`:
    case `${TYPES.GET_TIMEZONES}_PENDING`:
    case `${TYPES.GET_USER_RESTRICTIONS}_PENDING`:
      return {
        ...state,
        loading: true
      };
    case `${TYPES.GET_ROLES}_FULFILLED`:
      return { ...state, roles: action.payload };
    case `${TYPES.GET_ENTITIES}_FULFILLED`:
      return { ...state, entities: action.payload };
    case `${TYPES.GET_USER_RESTRICTIONS}_FULFILLED`:
      return { ...state, restrictions: action.payload };
    case `${TYPES.GET_TIMEZONES}_FULFILLED`:
      return { ...state, timeZones: action.payload, loading: false };

    case TYPES.UPDATE_USER_FIELD:
    case `${TYPES.UPDATE_USER_FIELD}_FULFILLED`:
      console.log(action.payload);
      const { user } = action.payload;
      return { ...state, selectedUser: user, success: true };

    case 'CLOSEMESSAGE':
      return { ...state, success: null, error: null };

    /** ***********************Change action states START ************************** */
    case `${TYPES.SET_PASSWORD}_PENDING`:
      return Object.assign({}, state, { loading: true });

    case `${TYPES.SET_PASSWORD}_FULFILLED`:
      return {
        ...state,
        ...{
          loading: false,
          success: true
        }
      };

    case `${TYPES.SET_PASSWORD}_REJECTED`:
      return {
        isRejected: true,
        error: 'Fetch Question action Failed'
      };

    default:
      return { ...state, selectedUserId: null, toolbarMode: 'LIST' };
  }
};

const UserManagement = combineReducers({
  searchBar: searchBarReducer,
  users
});

export default UserManagement;



// WEBPACK FOOTER //
// ./src/features/userManagement/store/reducer.js